export default "__VITE_ASSET__3ac6536b__"